import React from "react";
import { APPRAISAL_LIMITS, clampLen } from "./appraisalValidation";

/** Compact character counter under text fields. */
export const AppraisalCharCount = ({ value, max }) => {
  if (!max) return null;
  const len = String(value ?? "").length;
  const near = len >= Math.floor(max * 0.9);
  return (
    <small
      className={`appraisal-char-count${near ? " is-near" : ""}${len >= max ? " is-max" : ""}`}
      aria-live="polite"
    >
      {len}/{max}
    </small>
  );
};

/**
 * Controlled text input with maxLength + optional counter.
 * Pass `multiline` for textarea.
 */
export const AppraisalTextField = ({
  label,
  value,
  onChange,
  max = APPRAISAL_LIMITS.name,
  required = false,
  disabled = false,
  multiline = false,
  rows = 3,
  placeholder,
  hint,
  type = "text",
  showCount = true,
  id,
}) => {
  const handleChange = (e) => {
    onChange(clampLen(e.target.value, max));
  };

  const FieldTag = multiline ? "textarea" : "input";
  const fieldProps = multiline
    ? { rows }
    : { type };

  return (
    <label className="appraisal-field" htmlFor={id}>
      {label}
      <FieldTag
        id={id}
        required={required}
        disabled={disabled}
        maxLength={max}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={handleChange}
        {...fieldProps}
      />
      {hint ? <small className="appraisal-field-hint">{hint}</small> : null}
      {showCount ? <AppraisalCharCount value={value} max={max} /> : null}
    </label>
  );
};

export { APPRAISAL_LIMITS, clampLen };
